import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PlacementBanner = ({ message }) => {
    return (_jsx("div", { className: "placement-banner", children: _jsxs("div", { className: "alert alert-info py-2 px-3 mb-0 shadow-sm d-flex align-items-center", children: [_jsx("i", { className: "bi bi-geo-alt me-2" }), message] }) }));
};
